// components
import Card from '../../../../../components/atoms/card/card'
import RichText from '../../../../../components/atoms/rich-text/rich-text'
import ProgramCardInternal from '../program-card-internal/program-card-internal'
import '../../organisms/slideOnboarding/styles.scss'
import { IconClose } from '../IconClose'

export const FourthStep = ({ onClick, contentData, gotoNext }) => {
	return (
		<div className='container-item-slider schedule' onClick={gotoNext}>
			<IconClose onClick={onClick} />
			<Card classes='morphism'>
				{contentData && <RichText data={contentData} isContent classes='card-text' />}
			</Card>
			<ProgramCardInternal complementShadowElements={false} />
		</div>
	)
}
